module.exports = __webpack_public_path__ + "img/upper_arm.4eb0b823.png";